import moment from 'moment';

export type DurationInfo = {
    days: number;
    hours: number;
    minutes: number;
    expired: boolean;
};

// Now is mainly for testing purpose
export function getDurationInfo(timestamp: number, now = Date.now()) {
    const durationRaw = timestamp - now;
    const duration = moment.duration(durationRaw, 'milliseconds');
    const days = Math.max(Math.floor(duration.asDays()), 0);
    const hours = Math.max(Math.floor(duration.asHours()) % 24, 0);
    const minutes = Math.max(Math.floor(duration.asMinutes()) % 60, 0);
    const expired = durationRaw <= 0;
    return {
        days,
        hours,
        minutes,
        expired,
    };
}
